import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Send } from 'lucide-react';

const Outreach = () => (
  <div data-testid="outreach-page">
    <div className="mb-8">
      <h1 className="text-2xl lg:text-3xl font-bold tracking-tight">Outreach</h1>
      <p className="text-muted-foreground">Manage outbound communication campaigns</p>
    </div>
    <Card className="bg-card border-border card-glow">
      <CardContent className="py-16 text-center">
        <Send className="w-12 h-12 mx-auto text-muted-foreground mb-4" />
        <h3 className="font-semibold mb-2">Outreach Management</h3>
        <p className="text-muted-foreground">Use the Outreach Agent via Chat to draft and send messages to leads.</p>
      </CardContent>
    </Card>
  </div>
);

export default Outreach;
